import { Action } from 'redux';

import { Tab } from '../insight/experimental.tabset';

import { RootState } from './insight-explorer.state';

export enum ActionType {
    INSIGHT_EXPLORER__ROOT__INIT = 'INSIGHT_EXPLORER__INIT',
    INSIGHT_EXPLORER__ROOT__INIT_RESULT = 'INSIGHT_EXPLORER__INIT_RESULT',
    INSIGHT_EXPLORER__ROOT__SAVE = 'INSIGHT_EXPLORER__ROOT__SAVE',
    INSIGHT_EXPLORER__ROOT__SAVE_RESULT = 'INSIGHT_EXPLORER__ROOT__SAVE_RESULT',
    INSIGHT_EXPLORER__TABSET__SWITCH_TAB = 'INSIGHT_EXPLORER__TABSET__SWITCH_TAB',
    INSIGHT_EXPLORER__TABSET__REORDER_TAB = 'INSIGHT_EXPLORER__TABSET__REORDER_TAB',
    INSIGHT_EXPLORER__TABSET__ADD_TAB = 'INSIGHT_EXPLORER__TABSET__ADD_TAB',
    INSIGHT_EXPLORER__TABSET__CLOSE_TAB = 'INSIGHT_EXPLORER__TABSET__CLOSE_TAB',
    INSIGHT_EXPLORER__TABSET__RENAME_TAB = 'INSIGHT_EXPLORER__TABSET__RENAME_TAB',
    INSIGHT_EXPLORER__TABSET__SET_TAB_STATE = 'INSIGHT_EXPLORER__TABSET__SET_TAB_STATE',
}

export interface InitAction extends Action<ActionType> {}

export const rootInit = (): InitAction => ({
    type: ActionType.INSIGHT_EXPLORER__ROOT__INIT,
});

export interface InitResultAction extends InitAction {
    state: RootState;
}

export const rootInitResult = (state?: RootState): InitResultAction => ({
    type: ActionType.INSIGHT_EXPLORER__ROOT__INIT_RESULT,
    state,
});

/// //////////////////////

export interface SaveAction extends Action<ActionType> {
    state: RootState;
}

export const rootSave = (state: RootState): SaveAction => ({
    type: ActionType.INSIGHT_EXPLORER__ROOT__SAVE,
    state,
});

export interface SaveResultAction extends SaveAction {}

export const rootSaveResult = (state?: RootState): SaveResultAction => ({
    type: ActionType.INSIGHT_EXPLORER__ROOT__SAVE_RESULT,
    state,
});

/// //////////////////////

export interface TabsetSwitchTabAction extends Action<ActionType> {
    id: string;
}

export const tabsetSwitchTab = (id: string): TabsetSwitchTabAction => ({
    type: ActionType.INSIGHT_EXPLORER__TABSET__SWITCH_TAB,
    id,
});

/// //////////////////////

export interface TabsetReorderTabAction extends Action<ActionType> {
    id: string;
    index: number;
}

export const tabsetReorderTab = (
    id: string,
    index: number,
): TabsetReorderTabAction => ({
    type: ActionType.INSIGHT_EXPLORER__TABSET__REORDER_TAB,
    id,
    index,
});

/// //////////////////////

export interface TabsetAddTabAction extends Action<ActionType> {
    tab: Tab;
}

export const tabsetAddTab = (tab: Tab): TabsetAddTabAction => ({
    type: ActionType.INSIGHT_EXPLORER__TABSET__ADD_TAB,
    tab,
});

/// //////////////////////

export interface TabsetCloseTabAction extends Action<ActionType> {
    id: string;
}

export const tabsetCloseTab = (id: string): TabsetCloseTabAction => ({
    type: ActionType.INSIGHT_EXPLORER__TABSET__CLOSE_TAB,
    id,
});

/// //////////////////////

export interface TabsetRenameTabAction extends Action<ActionType> {
    id: string;
    label: string;
}

export const tabsetRenameTab = (
    id: string,
    label: string,
): TabsetRenameTabAction => ({
    type: ActionType.INSIGHT_EXPLORER__TABSET__RENAME_TAB,
    id,
    label,
});

/// //////////////////////

export interface TabsetSetTabStateAction extends Action<ActionType> {
    id: string;
    isDefault?: boolean;
    isFavourite?: boolean;
}

export const tabsetSetTabStateAction = (
    id: string,
    isDefault?: boolean,
    isFavourite?: boolean,
): TabsetSetTabStateAction => ({
    type: ActionType.INSIGHT_EXPLORER__TABSET__SET_TAB_STATE,
    id,
    isDefault,
    isFavourite,
});
